import { selectIsDiscord, selectIsMobile } from '../../selectors/app';
import { selectAutoPlayReady, selectIsIdle } from '../../selectors/player';

const shouldShowPlayer = (state) =>
  !selectIsIdle(state) ||
  selectAutoPlayReady(state) ||
  // Player should always show on Discord desktop
  (selectIsDiscord(state) && !selectIsMobile(state));

export default shouldShowPlayer;
